import React, { useState, useContext, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  MediumPageHeader,
  BoxWithLabelW,
  PrimaryText18,
  BlueText,
} from "./styleCustom";
import {
  TextArea,
  TextInput,
  TextDisplay,
  ButtonOrange,
  ButtonBlue,
} from "./formComponents";
import { errormsg } from "./Constants2";
//import "./styleForm.css";
//import "./styleFormik.css";
// import AuthHelperMethods from "./AuthHelperMethods";
import { MyContext, ListContext } from "./MyContext";

import { useAlert } from "react-alert";
import { useHistory, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { EditIconPlain } from "./icons";
import Select from "react-select";
import { customColors } from "./styleConstants";
import ContactForm from "./contactForm";
import PrivateRoute from "./privateRoute";
import { StaffAvatar } from "./images";

import Auth from "./Auth";

export const DetailDisplay = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);
  let staff = { ...listState.currentStaff };
  let cur = useParams();
  let currpersonoid = cur.person_id;

  //
  if (!staff) return null;
  return (
    <>
      <div
        className="details"
        style={{
          flex: "1 1 100%",
          maxWidth: 500,
          border: "solid 5px lightgrey",
          padding: 20,
          minHeight: 400,
          marginTop: 50,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 24,
            }}
          >
            <div className="avatarAndName">
              <StaffAvatar style={{ height: 100 }} />{" "}
              <BlueText style={{ fontSize: "18pt", cursor: "pointer" }}>
                {listState.currentStaff.name}
              </BlueText>
            </div>
            <div className="editIconAndLink">
              <Link
                style={{}}
                to={`/admin/staffhome/${listState.currentStaff.person_id}/edit`}
              >
                <EditIconPlain fontSize={"20px"} />
              </Link>
            </div>
          </div>

          {/* Jobs heading and roles string */}
          <div
            className="jobs"
            style={{ marginTop: 20, marginBottom: 10, fontSize: 20 }}
          >
            <span style={{ fontSize: 20 }}>Job Function</span>
            <div style={{ marginTop: 3 }}>
              {(() => {
                const roles = [
                  staff.is_instructor ? "Instructor/Trainer" : null,
                  staff.is_volunteer ? "Volunteer" : null,
                  staff.is_barnstaff ? "Barn Staff" : null,
                ].filter(Boolean);
                if (roles.length === 0) return <div>None</div>;
                return roles.map((role, idx) => <div key={idx}>{role}</div>);
              })()}
            </div>
          </div>
          <div className="avail" style={{ marginBottom: 10 }}>
            <span style={{ fontSize: 20 }}>Availability</span>
            <TextDisplay data={staff.availability || "n/a"} />
          </div>
          <div className="miscText" style={{ marginBottom: 10 }}>
            <span style={{ fontSize: 20 }}>General Notes </span>

            <TextDisplay data={staff.general_notes} />
            <TextDisplay data={staff.general_notes2} />
            <TextDisplay data={staff.general_notes3} />
          </div>
        </div>

        <PrivateRoute
          path={`${props.match.url}/contact/`}
          component={ContactForm}
        />
      </div>
    </>
  );
};

export const StaffColor = () => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);
  const [options_colors, set_options_colors] = useState([]);
  const [colorId, setColorId] = useState(
    listState.currentStaff.color_id || null,
  );

  let staff = { ...listState.currentStaff };

  useEffect(() => {
    const fetchData = async () => {
      const result = await Auth.api("colors/index", "get");
      console.log(result.data.colors);

      set_options_colors(
        result.data.colors.map((color) => ({
          label: color.color_name,
          value: color.id,
          other: color.id,
          color: color.color_code,
        })),
      );
    };
    fetchData();
  }, []);

  const changeColor = async (selected) => {
    // let currentStaff = { ...listState.currentStaff, color_id: selected.value };
    //dispatch2(["UPDATE_STAFF_COLOR", currentStaff]);
    dispatch2(["UPDATE_STAFF_COLORS", selected]);
    let params = {
      id: listState.currentStaff.instructor_id,
      color: selected.value,
    };
    const result = await Auth.api("instructors/updateColor", "post", params);
  };

  return (
    <Select
      onChange={(selected) => changeColor(selected)}
      className="form-control"
      options={options_colors}
      clearable={true}
      searchable={false}
      placeholder={"Select Color..."}
      styles={customColors}
      value={options_colors.filter(
        (option) => option.color == listState.currentStaff.color_code,
      )}
    />
  );
};

const StaffFormEdit = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);
  const [isEditing, setIsEditing] = useState(false);
  const [options_colors, set_options_colors] = useState([]);
  let history = useHistory();
  let staff = { ...listState.currentStaff };

  const [colorId, setColorId] = useState(
    listState.currentStaff.color_id || null,
  );
  console.log(listState.currentStaff.id);
  console.log(options_colors);

  console.log(
    options_colors.filter(
      (color) => color.value == listState.currentStaff.color_id,
    ),
  );
  const alert = useAlert();
  //
  //console.log(addoredit);
  useEffect(
    () => {
      /*    let horsearray = Object.entries(listState.currentHorse);

      let formInitialValues = horsearray.map(
        horse => `${horse[0]}: ${horse[1]}`
      );
      dispatch2(["SET_FORM_INITIAL_VALUES", listState.currentHorse]);*/

      let formInitialValues = {
        id: staff.instructor_id,
        color: staff.color_id || "",
        availability: staff.availability || "",
        general_notes: staff.general_notes || "",
        general_notes2: staff.general_notes2 || "",
        general_notes3: staff.general_notes3 || "",
        is_instructor: !!staff.is_instructor || false,
        is_volunteer: !!staff.is_volunteer || false,
        is_barnstaff: !!staff.is_barnstaff || false,
      };
      dispatch2(["SET_FORM_INITIAL_VALUES", formInitialValues, "edit"]);
      // dispatch2(["STUDENT_DETAIL_SET", result.data.student]);
    },
    //eslint-disable-next-line
    [listState.currentStaff],
  );

  useEffect(() => {
    const fetchData = async () => {
      const result = await Auth.api("colors/index", "get");
      console.log(result.data.colors);

      set_options_colors(
        result.data.colors.map((color) => ({
          label: color.color_name,
          value: color.id,
          other: color.id,
          color: color.color_code,
        })),
      );
    };
    fetchData();
  }, []);

  const changeColor = async (selected) => {
    let currentStaff = { ...listState.currentStaff, color_id: selected.value };
    dispatch2(["UPDATE_STAFF_COLOR", currentStaff]);
    let params = {
      id: listState.currentStaff.id,
      color: listState.currentStaff.selected.value,
    };
    const result = await Auth.api("instructors/update", "post", params);
  };

  const goToDetails = () => {
    const { pathname } = history.location;
    const newPath = pathname.replace(/\/edit$/, "/details");
    history.push(newPath);
  };
  // if (!staff) return null;

  return (
    <>
      <div
        className="staffFormEdit"
        style={{
          display: "flex",
          flex: "1 1 100%",
          marginBottom: 20,
          flexWrap: "wrap",
        }}
      >
        <Formik
          initialValues={listState.formInitialValues}
          enableReinitialize
          validationSchema={Yup.object({
            is_instructor: Yup.boolean(),
            is_volunteer: Yup.boolean(),
            is_barnstaff: Yup.boolean(),
            availability: Yup.string(),
            general_notes: Yup.string(),
            general_notes2: Yup.string(),
            general_notes3: Yup.string(),
          })}
          onSubmit={async (values, { setSubmitting }) => {
            //  e.preventDefault();
            //options_colors values.color = listState.selectedColor.value;

            dispatch({ type: "FETCH_INIT" });

            try {
              const result = await Auth.api(
                "instructors/update",
                "post",
                values,
              );

              // dispatch2(["STAFF_EDIT", result.data]);
              dispatch({ type: "FETCH_SUCCESS" });
              setSubmitting(false);
              // dispatch2(["STAFF_GET", result.data]);
              dispatch2(["STAFF_GET_ONE", result.data.staff[0]]);
              goToDetails();
            } catch (error) {
              console.log(error);
              dispatch({ type: "FETCH_ERROR" });
              alert.show(errormsg, { timeout: 5000, type: "error" });
            }
            //  dispatch2(["CLOSE_ADD_EDIT_FORM"]);
          }}
        >
          <Form
            id="staffForm"
            style={{
              display: "flex",
              flex: "1 1 100%",
              justifyContent: "space-evenly",
              alignItems: "flexStart",
              flexWrap: "wrap",
              margin: 30,
            }}
          >
            <div
              style={{
                display: "flex",
                flex: "1 1 100%",
                justifyContent: "center",
              }}
            >
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: "1 1 100%",
                    maxWidth: 500,
                    border: "solid 15px lightgrey",
                    padding: 20,
                    paddingBottom: 30,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flex: "1 1 100%",
                      justifyContent: "center",
                      marginBottom: 2,
                    }}
                  >
                    <MediumPageHeader>{"Edit Staff Details"}</MediumPageHeader>
                  </div>
                  <StaffColor />
                  {/* <BoxWithLabelW label={"Color"}>
                    <Select
                      onChange={(selected) => changeColor(selected)}
                      className="form-control"
                      options={options_colors}
                      clearable={true}
                      searchable={false}
                      placeholder={"Select Color..."}
                      styles={customColors}
                      value={options_colors.filter(
                        (option) =>
                          option.value == listState.currentStaff.color_id,
                      )}
                    />
                  </BoxWithLabelW>
                  */}
                  {/* Added instructor/volunteer/barnstaff checkboxes */}
                  <BoxWithLabelW label="Job Function">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: 10,
                        marginTop: 10,
                        fontSize: 22,
                        gap: 16,
                      }}
                    >
                      <label style={{ fontSize: 14 }}>
                        <Field
                          type="checkbox"
                          name="is_instructor"
                          style={{ width: 24, height: 24, marginRight: 12 }}
                        />{" "}
                        Instructor/Trainer
                      </label>
                      <label style={{ fontSize: 14 }}>
                        <Field
                          type="checkbox"
                          name="is_volunteer"
                          style={{ width: 24, height: 24, marginRight: 12 }}
                        />{" "}
                        Volunteer
                      </label>
                      <label style={{ fontSize: 14 }}>
                        <Field
                          type="checkbox"
                          name="is_barnstaff"
                          style={{ width: 24, height: 24, marginRight: 12 }}
                        />{" "}
                        Barn Staff
                      </label>
                    </div>
                  </BoxWithLabelW>
                  <TextInput name="availability" label="Availability" />

                  <TextArea
                    rows="3"
                    label={"General Notes 1"}
                    name="general_notes"
                  />
                  <TextArea
                    rows="3"
                    label={"General Notes 2"}
                    name="general_notes2"
                  />
                  <TextArea
                    rows="3"
                    label={"General Notes 3"}
                    name="general_notes3"
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      marginTop: 30,
                    }}
                  >
                    <ButtonBlue onClick={goToDetails} label={"Cancel"} />

                    <ButtonOrange
                      formId={"staffForm"}
                      type="submit"
                      label={"Save"}
                    />
                  </div>
                </div>
              </>
            </div>
          </Form>
        </Formik>
      </div>{" "}
    </>
  );
};
export default StaffFormEdit;
